import AppConfig from '@/AppConfig';

export default class OptimizelyService {
  public static trackEvent(eventName: string, tags: object | null = null): void {
    window['optimizely'] = window['optimizely'] || [];

    // Sends a tracking call to Optimizely for the given event name
    const data = {
      type: 'event',
      eventName: eventName,
    };

    if (tags) {
      Object.assign(data, { tags });
    }

    window['optimizely'].push(data);
  }

  public static isAbTestVariantActive(experimentId: string | null = null, variantId: string | null = null): boolean {
    if (experimentId === null || variantId === null) return false;
    if (this.optimizelyIsNotInitialized()) return false; // If Optimizely is not active/available

    const optimizelyState = window.optimizely.get('state');
    return (
      optimizelyState.getActiveExperimentIds().includes(experimentId) &&
      optimizelyState.getVariationMap()[experimentId].id == variantId
    );
  }

  public static optimizelyIsNotInitialized(): boolean {
    return window.optimizely === undefined || !window.optimizely.initialized;
  }

  public static isUserOnAbtestVariantCNV2936(): boolean {
    return OptimizelyService.isAbTestVariantActive(
      AppConfig.getCNV2936ExperimentId(),
      AppConfig.getCNV2936VariationId()
    );
  }
}
